import { Component } from '@angular/core';
import {Hr} from '../../../../shared/components/hr/hr';

@Component({
  selector: 'app-selection-header',
  imports: [
    Hr
  ],
  templateUrl: './selection-header.component.html',
  styleUrl: './selection-header.component.css'
})
export class SelectionHeaderComponent {

}
